import { RequestConfig } from '@/interface'

const PRIFIX = 'ypgl/tsgx/'
const taxRefundCheckConfig: RequestConfig = {
  // 退税勾选发票文件上传
  tsgxFpUpload: {
    url: `${PRIFIX}fpUpload`,
    method: 'post'
  },
  // 退税勾选海关缴款书文件上传
  tsgxHgjksUpload: {
    url: `${PRIFIX}hgjksUpload`,
    method: 'post'
  },
  // 企业统计
  tsgxQytj: {
    url: `${PRIFIX}qytj`,
    method: 'post'
  },
  // 退税勾选
  tsgx: {
    url: `${PRIFIX}tsgx`,
    method: 'post'
  },
  // 退税勾选文件上传结果列表查询
  tsGxFileUploadList: {
    url: `${PRIFIX}tsGxFileUploadList`,
    method: 'post'
  },
  // 退税勾选文件上传状态查询
  tsGxFileUploadResult: {
    url: `${PRIFIX}tsGxFileUploadResult`,
    method: 'post'
  },
  // 发票明细列表-海关缴款书
  tsgxHgjkslb: {
    url: `${PRIFIX}tsgxHgjkslb`,
    method: 'post'
  },
  // 退税勾选结果
  tsgxjg: {
    url: `${PRIFIX}tsgxjg`,
    method: 'get'
  },
  // 退税勾选统计
  tsgxTjjg: {
    url: `${PRIFIX}tsgxTjjg`,
    method: 'post'
  }
}
export default taxRefundCheckConfig
